// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__130tS","footer":"ModalCreateQualiphyProcedure_footer__3JzrO","additionData":"ModalCreateQualiphyProcedure_additionData__mp1Uq"};